<section class="fms-diagnose" aria-labelledby="fms-diagnose-title">
  <header class="header">
    <div class="heading">
      <span class="bunny" data-test="fms-diagnose-bunny">
        <mat-icon svgIcon="cruelty_free" aria-hidden="true"></mat-icon>
      </span>
      <div>
        <h1 id="fms-diagnose-title" mat-dialog-title>
          {{ data.title }} {{ searchForm.controls.year.value }}
        </h1>
        @if (summaryState$ | async; as state) {
          @if (state.kind === 'loaded') {
            <p>{{ state.data.customer.name }} · {{ state.data.customer.customerNumber }}</p>
          }
        }
      </div>
    </div>
    <button
      mat-icon-button
      type="button"
      (click)="cancel()"
      [attr.aria-label]="'close' | translate"
      data-test="fms-diagnose-close"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </header>

  <mat-tab-group
    class="tabs"
    [selectedIndex]="selectedTabIndex"
    (selectedIndexChange)="onTabChange($event)"
    animationDuration="0ms"
  >
    <mat-tab [label]="'1. ' + ('fmsDiagnose.tabs.linkage.title' | translate)">
      <app-fms-diagnose-linkage-tab
        [summaryState$]="summaryState$"
        [searchState$]="searchState$"
        [searchForm]="searchForm"
        [years]="years"
        [filteredCustomers$]="filteredCustomers$"
        (retryRequested)="retry()"
        (retrySearchRequested)="retrySearch()"
      ></app-fms-diagnose-linkage-tab>
    </mat-tab>
    <mat-tab
      [label]="'2. ' + ('fmsDiagnose.tabs.cropFields.title' | translate)"
      bodyClass="crop-fields-tab-body"
    >
      <app-fms-diagnose-crop-fields-tab
        [cropFieldsState$]="cropFieldsState$"
        (retryRequested)="retryCropFields()"
      ></app-fms-diagnose-crop-fields-tab>
    </mat-tab>
    <mat-tab [label]="'3. ' + ('fmsDiagnose.tabs.sprays.title' | translate)">
      <app-fms-diagnose-sprays-tab
        [spraysState$]="spraysState$"
        (retryRequested)="retrySprays()"
      ></app-fms-diagnose-sprays-tab>
    </mat-tab>
  </mat-tab-group>
</section>
